var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "reconciliation-step-template",
    {
      attrs: { nextStep: _vm.nextStep, previousStep: _vm.previousStep },
      on: {
        next: _vm.goToNextStep,
        previous: function($event) {
          return _vm.$emit("previous")
        }
      }
    },
    [
      _c(
        "template",
        { slot: "content" },
        [
          _c("h3", [_vm._v(_vm._s(_vm.$l10n.__("Montant de la transaction")))]),
          _vm._v(" "),
          _c("p", { staticClass: "fs-3 semibold mt-4 mb-2" }, [
            _vm._v(
              _vm._s(
                _vm.$l10n.__(
                  "Sélectionnez le type d’affichage que vous rencontrez et définissez le type de la colonne montant."
                )
              )
            )
          ]),
          _vm._v(" "),
          _c(
            "custom-radio-group",
            _vm._l(_vm.amountTypes, function(amountType, amountTypeIndex) {
              return _c(
                "custom-radio-item",
                {
                  key: amountTypeIndex,
                  attrs: { data: amountType },
                  on: { input: _vm.resetSelectedColumns },
                  model: {
                    value: _vm.value.template.amountType,
                    callback: function($$v) {
                      _vm.$set(_vm.value.template, "amountType", $$v)
                    },
                    expression: "value.template.amountType"
                  }
                },
                [
                  _c("div", { staticClass: "circle" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "illu mt-3" }, [
                    _c("img", {
                      attrs: {
                        src:
                          "/ressources/logged/img/bankreconciliation/" +
                          amountType.value +
                          ".png",
                        alt: ""
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "fs-3 gray-80" }, [
                    _vm._v(_vm._s(amountType.label))
                  ])
                ]
              )
            }),
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "mt-3" }, [
            _c("p", { staticClass: "fs-3 gray-80 mt-4 mb-2" }, [
              _vm._v(_vm._s(_vm.activeAmountType.info))
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "fs-3 semibold mt-4 mb-2" }, [
              _vm._v(
                "\n                " +
                  _vm._s(
                    _vm.$l10n.__(
                      "Sélectionnez la colonne puis cliquez sur continuer."
                    )
                  ) +
                  "\n            "
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "step-container-table border-black" },
              [
                _c("table-selectable-columns", {
                  attrs: { lines: _vm.csv, max: 1 },
                  model: {
                    value: _vm.selectedColumns,
                    callback: function($$v) {
                      _vm.selectedColumns = $$v
                    },
                    expression: "selectedColumns"
                  }
                })
              ],
              1
            )
          ])
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }